import styled from '@emotion/styled';
import { CommonBG, CommonBorder, CommonText } from 'ui/theme/Color';
import { SVGIcon } from 'components/buttons/IconSVG';

//프로젝트 요약 Layout
export const SummaryContainer = styled.div`
  position: relative;
  display: grid;
  min-width: 1020px;
  height: calc(100vh - 160px);
  grid-template-columns: 1.2fr 1fr;
  grid-template-rows: 1fr 260px 260px;
  gap: 10px;
  align-items: stretch;
  .userMetadata {
    position: absolute;
    top: -46px;
    right: 0;
    display: flex;
    align-items: center;
    background: ${CommonBG.Basic};
    span {
      margin: 0 6px 0 16px;
      font-size: 14px;
      font-weight: 600;
    }
  }
`;

//공장_Container Layout
export const FactoryContainer = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 250px 1fr;
  column-gap: 20px;
  .scroll {
    max-height: 179px;
    overflow-x: hidden;
    overflow-y: auto;
    border: 1px solid ${CommonBorder.Basic};
    > div {
      margin-top: -1px;
      margin-left: -1px;
      border-right: none;
      border-bottom: none;
    }
  }
  .poRBtn {
    top: -50px;
  }
  .mapDetailContents {
    display: grid;
    grid-template-rows: 0.9fr 0.9fr 0.9fr;
    min-height: 0;
    .mapLayout {
      // height: 358px;
    }
    & > div:not(:last-child) {
      border-bottom: none;
    }
  }
  .mapContents {
    display: grid;
    row-gap: 20px;
    grid-template-rows: 358px 1fr;
    min-width: 0;
    height: 100%;
    .gridHeight {
      height: 218px;
    }
  }
`;

//FOB_Container Layout
export const FOBContainer = styled.div`
  .mapView {
    position: relative;
    display: flex;
    gap: 16px;
    width: 100%;
    margin-bottom: 24px;
    .items {
      width: 460px;
      ul {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-auto-rows: 130px;
        grid-gap: 8px;
        overflow-y: auto;
        &.height_1 {
          height: calc(100vh - 420px);
          min-height: 300px;
        }
        &.height_2 {
          height: calc(100vh - 510px);
          min-height: 350px;
        }
        li {
          display: flex;
          align-items: center;
          justify-content: center;
          button {
            height: 100%;
            width: 100%;
            border-radius: 8px;
            border: 1px ${CommonBorder.Basic} solid;
            flex-direction: column;
            font-size: 20px;
            color: ${CommonText.PrimaryExtreme};
            background: ${CommonBG.Deep};
            letter-spacing: -0.5px;
            strong {
              display: block;
              font-size: 20px;
            }
            span {
              display: block;
              margin-top: 5px;
              font-size: 16px;
              font-weight: 600;
            }
          }
          &.selected {
            button {
              color: #fff;
              background-image: linear-gradient(to right, #2d9bb2, #3ec2cf);
            }
          }
        }
      }
    }
    .note {
      position: absolute;
      bottom: -24px;
      right: 0;
      font-size: 12px;
      display: flex;
      align-items: center;
      gap: 6px;
      &:before {
        content: '';
        display: inline-block;
        width: 18px;
        height: 18px;
      }
      &.info {
        &:before {
          -webkit-mask: ${SVGIcon.IcoInfo};
          mask-image: ${SVGIcon.IcoInfo};
        }
      }
      &.primary {
        color: ${CommonText.Primary};
        &:before {
          background: ${CommonText.Primary};
        }
      }
    }
  }
`;
